import Api from '@/core/classes/Api';
import { makeAxiosInstance } from './axios';

const baseURL = process.env.VUE_APP_APIENDPOINT;

const api = new Api(makeAxiosInstance(baseURL));

export default api;
